import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id AEE38946-ADDE-4AFA-B450-D13590926CA4
 * name faucet
 * version: 6.9.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/faucet.svg
 * tags
 * - Home Automation 
 */
export const FaucetIcon = createSvgIcon(<><path d="M19 14V16H16V14.28L19 14M19 13C19 11.9 18 11 16.8 11H10V10H5V21H10V13.91L19 13M5 9H10V7L15.36 5.21C15.74 5.09 16 4.73 16 4.33C16 3.68 15.36 3.23 14.75 3.45L5 7V9Z" /></>, 'FaucetIcon');
export default FaucetIcon